export class DevicePartialSuccessError extends Error {
    constructor(processedDeviceIds, notProcessedDeviceIds, partiallyProcessedDeviceIds) {
        super(`Processed device ids: ${processedDeviceIds}, not processed device ids: ${notProcessedDeviceIds}, partially processed device ids: ${partiallyProcessedDeviceIds}.`);
        this.processedDeviceIds = processedDeviceIds;
        this.notProcessedDeviceIds = notProcessedDeviceIds;
        this.partiallyProcessedDeviceIds = partiallyProcessedDeviceIds;
        this.name = 'DevicePartialSuccessError';
    }
}
